/* eslint-disable unicorn/filename-case -- TODO rename later */
export enum ZitadelRoles {
  ADMIN = "ORG_OWNER",
  CUSTOMER_ADMIN = "customer_admin",
}
